import React, { useCallback, useEffect, useRef, useState } from 'react'

const MessageCompositeField = ({
    prefix,
    suffix = '',
    placeholder,
    value = '',
    onValueChanged,
}) => {
    const textareaRef = useRef(null)
    const [focused, setFocused] = useState(false)

    const resize = useCallback(() => {
        const textarea = textareaRef.current
        if (!textarea) return
        const lineHeight = parseFloat(getComputedStyle(textarea).lineHeight) || 20
        textarea.style.height = `${lineHeight}px`
        textarea.style.height = `${Math.max(lineHeight, textarea.scrollHeight)}px`
    }, [])

    useEffect(() => {
        resize()
    }, [value, prefix, resize])

    const focusTextarea = () => textareaRef.current?.focus()

    return (
        <div
            className={[
                'message-composite-field',
                'dx-texteditor',
                'dx-editor-outlined',
                'dx-textarea',
                focused ? 'dx-state-focused' : '',
                value ? '' : 'dx-texteditor-empty',
            ].filter(Boolean).join(' ')}
            onClick={focusTextarea}
        >
            <div className="dx-texteditor-container">
                <div className="message-composite-field__body dx-texteditor-input-container">
                    <span className="message-composite-field__prefix">{prefix}</span>
                    <textarea
                        ref={textareaRef}
                        className="message-composite-field__input dx-texteditor-input"
                        value={value}
                        placeholder={placeholder}
                        rows={1}
                        onChange={(e) => onValueChanged?.(e.target.value)}
                        onInput={resize}
                        onFocus={() => setFocused(true)}
                        onBlur={() => setFocused(false)}
                    />
                    {suffix ? <span className="message-composite-field__suffix">{suffix}</span> : null}
                </div>
            </div>
        </div>
    )
}

export default MessageCompositeField
